angular.module 'zc.users'

  .directive 'languageSelectHeader', (
    $location,
    $rootScope,
    $state,
    $translate,
    $window,
    Devise,
  ) ->
    directive =
      restrict: "EA"
      scope: {}
      replace: true
      templateUrl: '/templates/users/views/directives/language_select_header.html'
      link: (scope, element, attrs) ->

        scope.availableLanguages = $translate.getAvailableLanguageKeys()
        scope.getLanguageLabel = (lang, forceLanguage) ->
          unless lang
            lang = $translate.use()
          $translate.instant("sharedModules.common.i18n.code.#{lang}", {}, undefined, forceLanguage)

        scope.setLanguage = (lang) ->
          $translate.use lang
          $rootScope.$emit 'languageSelected', lang
          $window.document.documentElement.lang = lang

        Devise
          .getCurrentUserLanguage()
          .then (currentUserLanguage) ->
            languageId = $location.search().lang || currentUserLanguage || $translate.preferredLanguage()
            scope.setLanguage(languageId)


    directive



// WEBPACK FOOTER //
// ./src/zenclerk_modules/users/directives/language_select_header_directive.js.coffee